export class DeviceBoxTuyaPRSManagement {
    switchState(deviceId, label, isOn) {
        if (!this._isDeviceAvailable) {
            return
        }
        this._onStateChange('TUYA_PR_' + deviceId, 'SET_SWITCH', !isOn).then(() => {
        }).catch(() => {
        })
    }
}

export default function HousePilotDeviceBoxTuyaPRS({ prs, onStateChange }) {
    const isDeviceAvailable = Array.isArray(prs) && prs.length > 0
    const hasActive = isDeviceAvailable && prs.some((pr) => pr?.data?.switch === true)
    const manager = new DeviceBoxTuyaPRSManagement()
    manager._onStateChange = onStateChange
    manager._isDeviceAvailable = isDeviceAvailable

    return (
        <>
            <div className={"m-1 col-3 col-sm-5 col-md-6 col-lg-3 deviceBox " + (hasActive ? ' active' : '') + (isDeviceAvailable ? '' : ' unavailable')}>
                <h6>Prises <i className="fa fa-plug"></i></h6>
                {isDeviceAvailable ? (
                    prs.map((pr) => {
                        const toggleValue = pr?.data?.switch === true ? 'on' : 'off'
                        const label = pr.label || 'Inconnu'
                        return (
                            <div className="align-items-center" key={pr.id}>
                                <span>{label}</span>
                                <i className={"fa fa-lg fa-toggle-" + toggleValue} onClick={() => { manager.switchState(pr.id, label, pr.data?.switch) }}></i>
                            </div>
                        )
                    })
                ) : (
                    <div className="deviceBox-overlay"><span className="deviceBox-overlay-label">Hors ligne</span></div>
                )}
            </div>
        </>
    )
}
